import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const VisibilityOffIcon = styled.div`
  color: ${({ error }) => (error ? colors.strongRed : colors.strongGray)};
`
export const VisibilityIcon = styled.div`
  color: ${({ error }) => (error ? colors.strongRed : colors.strongGray)};
`
export const ContainerError = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  color: ${colors.strongRed};
  font-size: 12px;
  font-weight: 450;
  line-height: 16px;
  margin-top: 4px;
`
export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`

export const InputContainer = styled.div`
  margin-top: 8px;
  position: relative;
  font-size: inherit;
  margin-bottom: 20px;
`

export const IconContainer = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
`

export const EyeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
